const dynpackCatalog = new Set();

// Error management
dynpackCatalog
    .add('dp-popup-session-expired')
    .add('dp-popup-broken-flow')
    .add('dp-popup-no-results')
    .add('dp-banner-no-availability-results');

// Results List
dynpackCatalog
    .add('dp-accommodation-results-hotel-card-book-btn')
    .add('dp-accommodation-results-hotel-card-prime-book-btn')
    .add('dp-general-map-hotel-card-book-btn')
    .add('dp-general-map-hotel-card-prime-book-btn')
    .add('dp-filters-hotel-facility')
    .add('dp-filters-distance-center')
    .add('dp-filters-hotel-name')
    .add('dp-filters-price')
    .add('dp-filters-reservation-policy')
    .add('dp-filters-close-to-location')
    .add('dp-filters-accommodation-type')
    .add('dp-filters-category')
    .add('dp-filters-review')
    .add('dp-filters-neighbourhood')
    .add('dp-pagination')
    .add('dp-sorting-best_selling')
    .add('dp-sorting-best_value_for_client')
    .add('dp-sorting-best_price')
    .add('dp-sorting-best_price_asc')
    .add('dp-sorting-close_to_location')
    .add('dp-sorting-discount_percentage')
    .add('dp-new-search-open')
    .add('dp-new-search-close')
    .add('dp-new-search-submit')
    .add('dp-new-search-submit:dp')
    .add('dp-new-search-submit:hsa')
    .add('dp-breadcrumb-accommodation')
    .add('dp-breadcrumb-flights')
    .add('dp-breadcrumb-details')
    .add('dp-breadcrumb-payment')
    .add('dp-breadcrumb-payment')
    .add('dp-change-hotel')
    .add('dp-change-flight');

export default dynpackCatalog;
